export default __webpack_public_path__ + "static/media/meta_logo.62070199.svg";